/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttachmentItemResVo1 } from './AttachmentItemResVo1';
import {
    AttachmentItemResVo1FromJSON,
    AttachmentItemResVo1FromJSONTyped,
    AttachmentItemResVo1ToJSON,
    AttachmentItemResVo1ToJSONTyped,
} from './AttachmentItemResVo1';
import type { ReplyItemResVo } from './ReplyItemResVo';
import {
    ReplyItemResVoFromJSON,
    ReplyItemResVoFromJSONTyped,
    ReplyItemResVoToJSON,
    ReplyItemResVoToJSONTyped,
} from './ReplyItemResVo';

/**
 * 
 * @export
 * @interface FeedbackItemResVo
 */
export interface FeedbackItemResVo {
    /**
     * 反馈真实主键。
     * @type {number}
     * @memberof FeedbackItemResVo
     */
    id?: number;
    /**
     * 反馈类型：1错误报告、2改善提议。
     * @type {number}
     * @memberof FeedbackItemResVo
     */
    type?: number;
    /**
     * 按当前请求语言返回的类型名称。
     * @type {string}
     * @memberof FeedbackItemResVo
     */
    typeName?: string;
    /**
     * 反馈标题。
     * @type {string}
     * @memberof FeedbackItemResVo
     */
    title?: string;
    /**
     * 反馈正文。
     * @type {string}
     * @memberof FeedbackItemResVo
     */
    content?: string;
    /**
     * 处理状态：1待回复、2处理中、3已回复。
     * @type {number}
     * @memberof FeedbackItemResVo
     */
    status?: number;
    /**
     * 按当前请求语言返回的状态名称。
     * @type {string}
     * @memberof FeedbackItemResVo
     */
    statusName?: string;
    /**
     * 最近一次回复时间，未回复为空。
     * @type {string}
     * @memberof FeedbackItemResVo
     */
    lastReplyTime?: string;
    /**
     * 提交时间。
     * @type {string}
     * @memberof FeedbackItemResVo
     */
    createTime?: string;
    /**
     * 附件集合；列表查询不补全，详情查询返回。
     * @type {Array<AttachmentItemResVo1>}
     * @memberof FeedbackItemResVo
     */
    attachments?: Array<AttachmentItemResVo1>;
    /**
     * 管理端回复集合；列表查询不补全，详情查询返回。
     * @type {Array<ReplyItemResVo>}
     * @memberof FeedbackItemResVo
     */
    replies?: Array<ReplyItemResVo>;
}

/**
 * Check if a given object implements the FeedbackItemResVo interface.
 */
export function instanceOfFeedbackItemResVo(value: object): value is FeedbackItemResVo {
    return true;
}

export function FeedbackItemResVoFromJSON(json: any): FeedbackItemResVo {
    return FeedbackItemResVoFromJSONTyped(json, false);
}

export function FeedbackItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'lastReplyTime': json['lastReplyTime'] == null ? undefined : json['lastReplyTime'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(AttachmentItemResVo1FromJSON)),
        'replies': json['replies'] == null ? undefined : ((json['replies'] as Array<any>).map(ReplyItemResVoFromJSON)),
    };
}

export function FeedbackItemResVoToJSON(json: any): FeedbackItemResVo {
    return FeedbackItemResVoToJSONTyped(json, false);
}

export function FeedbackItemResVoToJSONTyped(value?: FeedbackItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'typeName': value['typeName'],
        'title': value['title'],
        'content': value['content'],
        'status': value['status'],
        'statusName': value['statusName'],
        'lastReplyTime': value['lastReplyTime'],
        'createTime': value['createTime'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(AttachmentItemResVo1ToJSON)),
        'replies': value['replies'] == null ? undefined : ((value['replies'] as Array<any>).map(ReplyItemResVoToJSON)),
    };
}

